import { hiddenField, stringField } from 'common/utils/form/fieldTypes';

const config = {
  id: hiddenField(),
  parent_id: stringField(),
  code: stringField({ required: true }),
  name: stringField({ required: true })
};

export default config;
